module.exports = __webpack_public_path__ + "img/funnel.b237456b.svg";